import { useFinanceModels } from '../api/hooks/financemodels';
import { useSelectedProducts } from './useCustomerCatalogueService';

export const useRequiredFinanceModels = () => {
  const selectedProducts = useSelectedProducts();
  const financeModels = useFinanceModels();

  return financeModels.filter(m => {
    if (!m.categoryId || !m.manufacturerId) {
      return true;
    }

    return selectedProducts.some(p => m.categoryId === p.category.id && m.manufacturerId === p.manufacturer.id);
  });
};

export const useIsPeripheralModelRequired = () => {
  const selectedProducts = useSelectedProducts();

  return !!selectedProducts.some(p => !p.category.isMainDevice);
};
